import React from 'react';
import {View} from 'MWC';
import tpl from '../templates/childrens';
import widgetsHelper from 'utils/getWidget.helper';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: <div />,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            mode: 'info',
            where_by: ['path'],
            search_by: [location.pathname],
            widgets: [],
            loader: true
        };
        this.widgetsHelper = widgetsHelper;
        this.scrollToOrderCard = this.scrollToOrderCard.bind(this);
    }

    componentDidMount() {
        this.widgetsHelper.getWidgets.call(this);
    }

    scrollToOrderCard = isMobile => {
        const targetElement = isMobile
            ? document.querySelector('.download-app-wrapper')
            : document.querySelector('.card-order-wrapper');
        this.setState({mode: 'info'}, () => {
            if (targetElement) {
                targetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }
        });
    };

    toggleMode = mode => {
        this.setState({mode: mode});
    };
}
